import styled, { css } from 'styled-components'
import { mobile, tablet } from '../../constants/breakpoints'

export const Page = styled.div`
  width: 100%;
  min-height: calc(100vh - 72px);
  margin: 72px auto 0 auto;
  background: #f8fcff;
  padding-top: 50px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: calc(${tablet})) {
    margin-top: -72px;
    padding-top: 72px;
  }
`

export const ContentWrap = styled.div`
  background-color: #fff;
  border-radius: 30px;
  border: 1px solid #b7bdc6;
  width: 100%;
  max-width: 742px;
  padding: 40px 60px;

  @media (max-width: calc(${tablet})) {
    border: none;
    padding: 20px 30px;
    background: #f8fcff;
  }

  h1 {
    width: 100%;
    text-align: center;
    color: #4c5197;
    font-family: Poppins;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 70px; /* 140% */
    margin: 0;
  }

  h2 {
    color: #4c5197;
    text-align: center;
    font-family: Poppins;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0 0 50px 0;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Footer = styled.div<{ $disabled?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button,
  a {
    user-select: none;
    text-decoration: none;
    outline: none;
    border: none;
    display: flex;
    width: 250px;
    height: 48px;
    min-width: 136px;
    padding: 4px 0px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    background: linear-gradient(90deg, #d587df 0%, #a25ee1 100%);
    color: var(--Button-Primary-text, #fff);
    text-align: center;

    /* Paragraph 3 - Medium */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-3, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: var(--Fonts-Line-height-Paragraph-3, 24px); /* 150% */
    letter-spacing: -0.16px;

    transition: box-shadow 0.2s ease-out, filter 0.2s ease-out;

    &:hover {
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
      cursor: pointer;
    }

    &:disabled {
      filter: grayscale();
    }

    &:hover:disabled {
      cursor: default;
      box-shadow: none;
    }

    ${({ $disabled }) =>
      $disabled &&
      css`
        filter: grayscale();
        pointer-events: none;
        cursor: default;
        &:hover {
          cursor: default;
          box-shadow: none;
        }
      `}
  }
`

export const TermItemContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 30px 1fr 46px;
  grid-template-rows: 29px auto;
  margin-bottom: 15px;

  h3 {
    grid-column: 1/4;
    grid-row: 1;

    color: #4c5197;
    font-family: Poppins;
    font-size: var(--Fonts-Size-Paragraph-3, 16px);
    font-style: normal;
    font-weight: 600;
    line-height: var(--Fonts-Line-height-Paragraph-3, 24px); /* 150% */
    letter-spacing: -0.16px;
    margin: 0;

    & > span {
      color: #d83535;
      font-family: Poppins;
      font-size: var(--Fonts-Size-Paragraph-3, 16px);
      font-style: normal;
      font-weight: 600;
      line-height: var(--Fonts-Line-height-Paragraph-3, 24px);
      letter-spacing: -0.16px;
    }
  }

  p {
    user-select: none;
    cursor: pointer;
    grid-column: 2;
    grid-row: 2;
    color: rgba(0, 0, 0, 0.76);
    font-family: Poppins;
    font-size: var(--Fonts-Size-Paragraph-3, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Fonts-Line-height-Paragraph-3, 24px); /* 150% */
    letter-spacing: -0.16px;
    margin: 0;
  }

  div {
    grid-column: 1;
    grid-row: 2;
  }

  a {
    grid-column: 3;
    grid-row: 2;
    cursor: pointer;
  }
`

export const ConsentCheckbox = styled.div<{ checked?: boolean }>`
  height: 24px;
  width: 24px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  user-select: none;
`

export const RequiredLine = styled.div`
  width: 100%;
  color: #d83535;
  font-family: Poppins;
  font-size: var(--Fonts-Size-Paragraph-2, 18px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Fonts-Line-height-Paragraph-2, 26px); /* 144.444% */
  letter-spacing: -0.45px;
  margin-bottom: 30px;
`
